import { render, staticRenderFns } from "./OpenImage.vue?vue&type=template&id=40824413"
import script from "./OpenImage.vue?vue&type=script&lang=ts"
export * from "./OpenImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports